<template>
  <div>
    <vs-alert
      color="danger"
      icon-pack="feather"
      icon="icon-info"
      v-for="(errors, err) in errorMessage"
      v-bind:key="err"
    >
      <span>{{ errors }}</span>
    </vs-alert>
    <table style="width: -webkit-fill-available">
      <thead>
        <th style="width: 9%">SiNo</th>
        <th style="width: 30%">Description</th>
        <th style="width: 9%">Qty</th>
        <th style="width: 9%">Rate</th>
        <th style="width: 9%">Amount</th>
        <th style="width: 13%">Tax</th>
        <th v-if="readonlyFlag == false" style="width: 5%">&nbsp;</th>
      </thead>
      <tbody v-if="BillData.billItems.length == 0">
        <tr>
          <td colspan="6">
            <vs-alert active="true" color="warning" style="text-align: center">
              <span>No Bills</span>
            </vs-alert>
          </td>
        </tr>
      </tbody>
      <tbody v-if="BillData.billItems.length != 0">
        <tr v-for="(bill, index) in BillData.billItems" v-bind:key="index">
          <td>
            <vs-input
              v-model="bill.slNo"
              style="width: 100%"
              class="configclass"
              tabindex="-1"
              readonly
            ></vs-input>
          </td>
          <td>
            <multiselect
              v-model="bill.billItem"
              :options="billItems"
              label="name"
              track-by="id"
              placeholder="Select Bill Item"
              :disabled="readonlyFlag || bill.readonly"
              @input="onBillItemSelected(bill.billItem, index)"
            ></multiselect>
          </td>
          <td>
            <vs-input
              :readonly="readonlyFlag"
              v-model="bill.qty"
              class="configclass"
              style="width: 100%"
              @keyup="showTotal"
            ></vs-input>
          </td>
          <td>
            <vs-input
              v-model="bill.rate"
              class="configclass"
              @keyup="showTotal"
              :readonly="readonlyFlag || bill.readonly"
            />
          </td>
          <td>
            <vs-input
              v-model="bill.amount"
              class="configclass"
              style="width: 100%"
              @keydown.tab="insertRow(index)"
              readonly
            />
          </td>

          <td>
            <select
              v-model="bill.taxId"
              class="vs-select--input myselect"
              style="height: 36px; width: 100%"
              @change="changeTaxAmount(index)"
              :disabled="readonlyFlag"
            >
              <option
                v-for="(item, index) in taxs"
                v-bind:key="index"
                :value="item.id"
              >
                {{ item.name }}
              </option>
            </select>
          </td>
          <td
            v-if="readonlyFlag == false"
            style="text-align: right; padding-right: 20px"
            title="delete"
          >
            <feather-icon
              icon="Trash2Icon"
              class="mr-0 cursor-pointer"
              style="color: #ff0000"
              @click="deleteRow(index)"
            ></feather-icon>
          </td>
        </tr>
      </tbody>
    </table>

    <vs-row>
      <table hoverFlat class="w-full ml-auto mt-4">
        <tbody>
          <tr>
            <th style="width: 17%; text-align: left; padding-left: 2px">
              Payment Mode
            </th>
            <td style="width:15%;text-align=left">
              <select
                v-model="BillData.paymentModeId"
                class="vs-select--input myselect"
                style="height: 36px; margin-bottom: 4%"
                @change="onChangePayment"
                :disabled="readonlyFlag"
              >
                <option
                  v-for="(item, index) in paymentModes"
                  v-bind:key="index"
                  :value="item.paymentId"
                >
                  {{ item.paymentMode }}
                </option>
              </select>
            </td>
            <td style="width: 38%"></td>
            <th style="width: 17%; text-align: left; padding-left: 2px">
              Sub Total
            </th>
            <td>
              <vs-input
                readonly
                v-model="BillData.subTotal"
                class="configclass"
                name="TokenAvailable"
              />
            </td>
          </tr>

          <tr>
            <th style="width: 17%; text-align: left; padding-left: 2px">
              Received Amount
            </th>
            <td style="width: 15%">
              <vs-input
                @keyup="showTotal"
                v-model="BillData.receiptAmount"
                class="configclass"
                :readonly="readonlyFlag"
                style="margin-bottom: 4%"
              />
            </td>
            <td style="width: 38%"></td>
            <th style="width: 17%; text-align: left; padding-left: 2px">
              Discount
            </th>
            <td>
              <vs-input
                @keyup="showTotal"
                v-model="BillData.discount"
                class="configclass"
                :readonly="readonlyFlag"
              />
            </td>
          </tr>

          <tr>
            <th style="width: 17%; text-align: left; padding-left: 2px">
              Balance Amount
            </th>
            <td style="width: 15%">
              <vs-input
                readonly
                v-model="BillData.balanceAmount"
                class="configclass"
                name="TokenAvailable"
                style="margin-bottom: 4%"
              />
            </td>
            <td style="width: 38%"></td>
            <th
              style="width: 17%; text-align: left; padding-left: 2px"
              colspan="3"
            >
              <table style="width: 104%">
                <tr
                  v-for="(bill, index) in BillData.billItems"
                  v-bind:key="index"
                >
                  <td
                    style="width: 19%; text-align: left"
                    v-if="bill.taxAmount > 0"
                  >
                    Gst @ {{ bill.taxAmount }}% on
                    {{
                      (
                        bill.amount -
                        (bill.amount * totalDiscount) / 100
                      ).toFixed(2)
                    }}
                  </td>
                  <td v-if="bill.taxAmount > 0" style="width: 15%">
                    <vs-input
                      readonly
                      v-model="bill.gstValue"
                      class="configclass"
                      style="margin-bottom: 4%"
                    />
                  </td>
                </tr>
              </table>

              <table style="width: 104%">
                <tr>
                  <th style="width: 18%; text-align: left; padding-left: 0px">
                    Total Amount
                  </th>
                  <td style="width: 15%">
                    <vs-input
                      readonly
                      v-model="BillData.totalAmount"
                      class="configclass"
                    />
                  </td>
                </tr>
              </table>
            </th>
          </tr>
          <tr></tr>
        </tbody>
      </table>
    </vs-row>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  data() {
    return {
      billItems: [
        {
          id: 0,
          name: "Select",
        },
      ],
      taxs: [{}],
      paymentModes: [{}],
      errorMessage: [],
      discountTypes: [
        {
          type: "V",
          typeName: "Discount Value",
        },
        {
          type: "P",
          typeName: "Discount Percentage",
        },
      ],
      totalDiscount: 0,
      gstShow: false,
    };
  },
  components: {
    Multiselect,
  },
  props: {
    BillData: {
      type: [Object, Array],
    },
    billingType: {
      type: Array,
      default: () => [], // default empty array
    },
    patientId: [Number, String],
    doctorId: [Number, String, null],
    readonlyFlag: {
      type: Boolean,
      default: false,
    },
  },
  beforeMount() {
    this.getbillItems();
    this.getTaxItems();
    this.getPaymentMode();
  },

  methods: {
    onChangePayment() {
      this.paymentModes.forEach((value) => {
        if (this.BillData.paymentModeId == value.paymentId) {
          this.BillData.paymentMode = value.paymentMode;
        }
      });
    },
    checkBillrows: function () {
      this.BillData.billItems.forEach((value, key) => {
        var count = 0;
        if (value.billItemId == 0) {
          count++;
        }
        if (!value.rate) {
          count++;
        }
        if (!value.amount || value.amount == 0) {
          count++;
        }
        if (count == 3) {
          if (this.BillData.billItems.length > 1) {
            this.$delete(this.BillData.billItems, key);
          }
        }
      });
      return true;
    },
    isNumeric: function (n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
    validateBill: function () {
      this.errorMessage = [];
      this.BillData.billItems.forEach((value, key) => {
        if (value.billItemId == 0) {
          this.errorMessage.push("Please select bill description!");
        }
        if (value.qty == 0 || !value.qty) {
          this.errorMessage.push("Please Enter valid Quantity !");
        } else if (!this.isNumeric(value.qty)) {
          this.errorMessage.push("Invalid Quantity !");
        }
        if (value.amount == 0 || !value.amount) {
          this.errorMessage.push("Please Enter valid Amount !");
        } else if (!this.isNumeric(value.amount)) {
          this.errorMessage.push("Invalid Amount !");
        }
        if (!this.isNumeric(value.rate)) {
          this.errorMessage.push("Invalid Rate !");
        }
        if (!this.isNumeric(value.gstValue)) {
          this.errorMessage.push("Invalid Tax Amount !");
        }
      });
      if (!this.isNumeric(this.BillData.subTotal)) {
        this.errorMessage.push("Invalid Subtotal !");
      }
      if (!this.isNumeric(this.BillData.balanceAmount)) {
        this.errorMessage.push("Invalid Balance Amount !");
      }
      if (!this.isNumeric(this.BillData.totalAmount)) {
        this.errorMessage.push("Invalid Total Amount !");
      }

      if (this.BillData.receiptAmount) {
        if (!this.isNumeric(this.BillData.receiptAmount)) {
          this.errorMessage.push("Invalid Receipt Amount !");
        }
      }

      if (this.errorMessage.length > 0) {
        return false;
      } else {
        return true;
      }
    },
    saveBill() {
      let cleanedBillItems = this.BillData.billItems.map((item) => ({
        ...item,
        billItemId: (item.billItem && item.billItem.id) || item.billItemId,
        billItem: (item.billItem && item.billItem.name) || item.billItem,
      }));

      var request = {
        companyId: this.$session.get("companyId"),
        patientId: this.patientId,
        billData: {
          ...this.BillData,
          billItems: cleanedBillItems,
        },
        userId: this.$session.get("userId"),
      };

      return this.$http
        .post("v2/savebills", JSON.stringify(request), {
          headers: { "Content-Type": "application/json" },
        })
        .then((response) => {
          this.BillData.billId = response.data.data.billId;
          this.readonlyFlag = true;
          this.$vs.notify({
            title: "Saved Successfully",
            color: "success",
            iconPack: "feather",
            icon: "icon-check",
            position: "top-center",
          });
          return true;
        })
        .catch((error) => {
          this.$vs.notify({
            title: "Error",
            text: "Error Occured Plz Try later",
            color: "danger",
            iconPack: "feather",
            icon: "icon-check",
            position: "top-center",
          });
          return false;
        });
    },

    getbillItems() {
      var request = {
        companyId: this.$session.get("companyId"),
        types: this.billingType,
      };
      this.$http
        .post("v2/getbillitems", JSON.stringify(request), {
          headers: { "Content-Type": "application/json" },
        })
        .then((response) => {
          response.data.data.forEach((value) => {
            this.billItems.push(value);
          });
        });
    },
    onBillItemSelected(selected, index) {
      if (!selected) return;
      this.BillData.billItems[index].billItemId = selected.id;
      this.getBillItemDetails(selected.id, index);
       if (this.BillData.billItems.length === index + 1) {
    let newRow = {
      slNo: this.BillData.billItems.length + 1,
      billItemId: 0,
      billItem: null,
      qty: "",
      rate: "",
      amount: "",
      taxId: 1,
      taxAmount: "",
      gstValue: "",
      readonly: false
    };

    this.BillData.billItems.push(newRow);
       }
    },

    getBillItemDetails(itemDetails, index) {
      console.log(
        "opTicketData doctorid in getBillItemDetails → ",
        this.doctorId
      );
      var request = {
        companyId: this.$session.get("companyId"),
        itemId: itemDetails,
        doctorId: this.doctorId || null,
      };
      console.log(" Sending Request to API:", request);
      this.$http
        .post("v2/getbillitemdetails", JSON.stringify(request), {
          headers: { "Content-Type": "application/json" },
        })
        .then((response) => {
          var mydata = response.data.data;
          this.BillData.billItems[index].rate = mydata.price;
          this.BillData.billItems[index].taxId = parseInt(mydata.taxId);
          /* this.BillData.billItems[index].billItem = { id: itemDetails, name: mydata.billItem };*/
          this.BillData.billItems[index].qty = 1;
          this.BillData.billItems[index].taxAmount = mydata.taxAmount;
          this.showTotal();
        })
        .catch((error) => {
          this.BillData.billItems[index].rate = null;
          this.BillData.billItems[index].taxId = null;
          this.BillData.billItems[index].taxAmount = 1;
          this.showTotal();
        });
    },
    getTaxItems() {
      this.$http
        .post("v2/gettaxdetails", {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.taxs = response.data.data;
        });
    },
    deleteRow(deleteRowIndex) {
      if (deleteRowIndex > 0) {
        this.$delete(this.BillData.billItems, deleteRowIndex);

        this.showTotal();
        this.$emit("rows-updated");
      }
    },
    insertRow(index) {
      if (this.BillData.billItems.length == index + 1) {
        var newrow = {
          slNo: this.BillData.billItems.length + 1,
          billItemId: 0,
          qty: "",
          rate: "",
          amount: "",
          taxId: 1,
          taxAmount: "",
          gstValue: "",
        };
        this.BillData.billItems.push(newrow);
        this.$emit("rows-updated");
      }
    },
    getPaymentMode() {
      this.$http
        .post("v2/getpaymentmode", {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          this.paymentModes = response.data.data;
        });
    },

    changeTaxAmount(index) {
      this.gstShow = true;
      this.taxs.forEach((value) => {
        if (value.id == this.BillData.billItems[index].taxId) {
          this.BillData.billItems[index].taxAmount = value.taxPer;
        }
      });
      this.showTotal();
    },
    showTotal() {
      // alert("showTotal");
      this.discountCalc();
      this.BillData.subTotal = 0;
      this.BillData.totalAmount = 0;
      this.BillData.balanceAmount = 0;
      this.BillData.billItems.forEach((value) => {
        value.amount = value.qty * value.rate;
        value.gstValue = (
          (value.taxAmount *
            (value.amount - (value.amount * this.totalDiscount) / 100)) /
          100
        ).toFixed(2);

        this.BillData.subTotal = (
          this.BillData.subTotal * 1 +
          value.amount * 1
        ).toFixed(2);
        this.BillData.totalAmount = (
          this.BillData.totalAmount * 1 +
          (value.amount * 1 -
            (value.amount * 1 * (this.totalDiscount * 1)) / 100) +
          value.gstValue * 1
        ).toFixed(2);
      });
      if (this.BillData.receiptAmount) {
        if (this.BillData.receiptAmount * 1 > this.BillData.totalAmount * 1) {
          this.BillData.receiptAmount = this.BillData.totalAmount * 1;
        }
        this.BillData.balanceAmount = (
          this.BillData.totalAmount * 1 -
          this.BillData.receiptAmount * 1
        ).toFixed(2);
      } else {
        this.BillData.balanceAmount = this.BillData.totalAmount * 1;
      }
    },
    discountCalc() {
      this.totalDiscount = 0;
      // alert(this.BillData.discount);
      if (this.BillData.discountType == "P") {
        var curVal = this.BillData.discount.split(".");
        this.BillData.discount = curVal[0] + "%";
      }
      var curDiscount = this.BillData.discount.split("%");
      if (curDiscount[0] * 1 > 0) {
        if (this.BillData.discount.indexOf("%") > -1) {
          // this.BillData.discount = curDiscount[0];
          this.BillData.discountType = "P";
          if (curDiscount[0] > 100) {
            this.BillData.discount = 100;
          } else {
            //    this.totalDiscount = (curDiscount[0]*this.BillData.subTotal/100).toFixed(2)
            // this.BillData.discount = curDiscount[0];
            this.totalDiscount = curDiscount[0];
          }
        } else {
          this.BillData.discountType = "V";
          if (this.BillData.discount * 1 > this.BillData.subTotal * 1) {
            this.BillData.discount = this.BillData.subTotal;
          }
          this.totalDiscount =
            (this.BillData.discount / this.BillData.subTotal) * 100;
        }
      }
    },
  },
};
</script>

<style scoped>
.configclass {
  width: -webkit-fill-available;
}

table {
  border-collapse: collapse;
}

table th {
  text-align: center;
}

table thead {
  background: #eaeff3;
}
.myselect:focus {
  border: 1px solid blue;
}
</style>
